import { Outlet } from "react-router-dom";

import { useAccount } from "components/AccountProvider";
import NoCompanyAccessPage from "pages/noCompany/NoCompanyAccessPage";
import SpinnerOverlay from "components/SpinnerOverlay";

/**
 * Route guard for the CV2 entry gate. Intercepts users who have not been provisioned for CV2 at all.
 *
 * - When `AccountProvider` detects a 403 with `X-Cv2-Access: not-enabled` on the accounts bootstrap,
 *   `cv2NotEnabled` becomes true and we render the "access not enabled" page in place of all routes.
 *
 * It deliberately does NOT gate on pending approval: a user whose company is still awaiting approval
 * is a provisioned CV2 user and must retain access to the SSOID-scoped master pages (My Profile,
 * Accounts & Roles, Request Company Account). The pending-approval gate lives in
 * `RequireCompanyAccess`, which wraps only the company-scoped routes (see ADR 0003).
 */
export default function RequireCv2Access() {
	const { isLoading, cv2NotEnabled } = useAccount();

	if (isLoading) {
		return <SpinnerOverlay open />;
	}

	if (cv2NotEnabled) {
		return <NoCompanyAccessPage accessNotEnabled />;
	}

	return <Outlet />;
}
